import type { Locale, NavLink } from "../types";
import { renderLogo } from "./logo";
import { renderLangSwitch } from "./lang-switch";

export function renderNav(
  brand: string,
  links: NavLink[],
  locale: Locale,
  locales: Locale[],
  themeToggleLabel: string,
): string {
  return `
    <nav>
      <a class="brand" href="#top" aria-label="${brand}">
        ${renderLogo()}
        <span class="word">${brand}</span>
      </a>
      <button class="menu-toggle" aria-label="Menu" aria-expanded="false" aria-controls="navlinks">
        <span></span><span></span>
      </button>
      <div class="nav-right" id="navlinks">
        <div class="navlinks">
          ${links.map((l) => `<a href="${l.href}">${l.label}</a>`).join("")}
        </div>
        ${renderLangSwitch(locale, locales)}
        <button type="button" class="theme-btn" aria-label="${themeToggleLabel}" title="${themeToggleLabel}">
          <span class="icon-sun" aria-hidden="true">☀</span>
          <span class="icon-moon" aria-hidden="true">☾</span>
        </button>
      </div>
    </nav>`;
}
